import {
    Routes,
    Route,
} from "react-router"

import HomePage from './Pages/Home'
import CreateBackgroundCheckCase from "./Pages/CreateBackgroundCheckCase"
import IndividualCasePage from "./Pages/IndividualCasePage"
import IndividualCaseDetails from "./Pages/IndividualCasePage/IndividualCaseDetails"
import BulkUploads from "./Pages/BulkUploads"
import PreChecks from "./Pages/PreChecks"
import PreCheck from "./Pages/PreCheck"
import PreCheckVerification from "./Pages/PreCheckVerification"
import PreCheckResultView from "./Pages/PreCheckResultView"
import ClientConsumerReport from "./Pages/ClientConsumerReport"
import CompanyBilling from "./Pages/CompanyBilling"
import CompanyUsers from "./Pages/CompanyUsers"

const Router = () => {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/create-background-check-case" element={<CreateBackgroundCheckCase />} />
            <Route path="/individual-case-page/:caseId" element={<IndividualCasePage />} />
            <Route path="/individual-case-details/:caseId" element={<IndividualCaseDetails />} />
            <Route path="/bulk-uploads" element={<BulkUploads />} />
            <Route path="/pre-checks" element={<PreChecks />} />
            <Route path="/pre-check/:preCheckId" element={<PreCheck />} />
            <Route path="/pre-check-verification/:preCheckVeriffId" element={<PreCheckVerification />} />
            <Route path="/pre-check-result-view/:preCheckId" element={<PreCheckResultView />} />
            <Route path="/client-consumer-report/:preCheckId" element={<ClientConsumerReport />} />
            <Route path="/company-billing" element={<CompanyBilling />} />
            <Route path="/company-users" element={<CompanyUsers />} />
            <Route path="*" element={<HomePage />} />
        </Routes>
    )
}

export default Router
